export default data => {
  for (let key in data) {
    if (data.hasOwnProperty(key) && data[key] instanceof Array) {
      data[key] = data[key].join(',')
    }
  }
  return data
}



// WEBPACK FOOTER //
// ./src/packages/plugins/src/axios/src/transformRequest/src/flatArray.js